const ROUTES = {
  HOME: "/",
  DATASETS: "/datasets",
  FTC_DATASETS: "/ftc",
  COUNTRIES: "/countries",
  CLIMATE_ASSISTANT: "/climate-assistant",
  ABOUT: "/about",
  ADMIN_LANDING_PAGE: "/admin-landing-page",
  ADMIN_LOGIN: "/admin-login",
};

export default ROUTES;
